var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.364,25.005h-4.371v-1.59c0-1.104-0.896-2-2-2H43.646c-1.104,0-2,0.896-2,2v1.59h-4.371c-1.104,0-2,0.896-2,2v7.381 c-3.363,0.156-6.505,1.523-8.901,3.92c-2.548,2.547-3.952,5.935-3.952,9.539c0,2.927,0.927,5.712,2.641,8.021l-9.567,9.567 c-0.781,0.781-0.781,2.047,0,2.828c0.39,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.414-0.586l9.567-9.567 c2.139,1.589,4.691,2.491,7.383,2.615v8.495c0,1.104,0.896,2,2,2h28.089c1.104,0,2-0.896,2-2V27.005 C67.364,25.9,66.469,25.005,65.364,25.005z M45.646,25.415h11.347v3.18H45.646V25.415z M26.422,47.844 c0-2.535,0.987-4.918,2.78-6.71s4.175-2.779,6.71-2.779c2.535,0,4.918,0.987,6.71,2.779c3.7,3.7,3.7,9.721,0,13.421 c-1.792,1.792-4.176,2.779-6.71,2.779c-2.535,0-4.918-0.987-6.71-2.779C27.41,52.762,26.422,50.379,26.422,47.844z M63.364,67.804 H39.275v-6.906c2.315-0.592,4.442-1.781,6.176-3.515c5.26-5.26,5.26-13.818,0-19.077c-1.734-1.734-3.861-2.923-6.176-3.515v-5.786 h2.371v1.59c0,1.104,0.896,2,2,2h15.347c1.104,0,2-0.896,2-2v-1.59h2.371V67.804z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipBoard);
export default __webpack_public_path__ + "static/media/clip-board.345af299584b65f0b56064c770c27a7b.svg";
export { ForwardRef as ReactComponent };